import { useState, useEffect } from 'react';
import { CloseOutlined, InfoOutlined, CampaignOutlined, ShoppingCartOutlined, Delete, DeleteOutline, Edit } from "@mui/icons-material";
import { grey } from "@mui/material/colors";
import { Button, Zoom, Tooltip, TableContainer, Table, TableHead, TableCell, TableBody, TableRow, Typography, IconButton } from "@mui/material";
import { socket } from "../../../../../../../components/Socket/cliente";
import { api, fetchCSRFToken } from "../../../../../../../services/api";
import SelectorLugares, { precioLista, tarifasLigadas } from "../../../../../../../components/compra/SelectorLugares";
import { useMapaCompra } from "../../../../../../../components/compra/MapaCompra";
import { useAuth } from "../../../../../../../components/context/AuthContext";
import { rgbaObjToString } from '../../../../../../../components/color/color';
import { eventoTieneTarifasConAprobacion } from '../../../../../../../utils/paymentCalculations';
const EventoTarifas = ({ data, cantidad, toggleDrawer, setCantidad, tarifasTicketsFiltrados, tarifasVouchersFiltrados, setTarifasSeleccionadas, asientosSeleccionados,
  setAsientosSeleccionados, isPreview = false }) => {

  const [modalSeleccionOpen, setModalSeleccionOpen] = useState(false);
  const { indice: indiceMapa } = useMapaCompra();
  const [tarifaSeleccionada, setTarifaSeleccionada] = useState(null);

  const [seleccionActual, setSeleccionActual] = useState({ asientos: [], mesas: {} });
  const [asientosOcupados, setAsientosOcupados] = useState([]);

  useEffect(() => {
    if (!data?.id) return;

    const eventoId = data.id;

    // escuchamos cambios del socket
    socket.on(`evento-${eventoId}-asientos-update`, (update) => {
      // actualizar la lista
      setAsientosOcupados(prev => {
        if (update.ocupado) {
          // si no esta en la lista, ocupamos
          return prev.includes(update.asientoId) ? prev : [...prev, update.asientoId];
        } else {
          // si al final no se ocupa, lo sacamos
          return prev.filter(id => id !== update.asientoId);
        }
      });
    });

    // limpiamos
    return () => {
      socket.off(`evento-${eventoId}-asientos-update`);
    };
  }, [data?.id]);

  const abrirModalSeleccion = (tarifa) => {
    setTarifaSeleccionada(tarifa);

    const seleccionPrevia = asientosSeleccionados[tarifa.id];

    if (seleccionPrevia) {
      setSeleccionActual(seleccionPrevia);
    } else {
      setSeleccionActual({ asientos: [], mesas: {} });
    }

    setModalSeleccionOpen(true);
  };

  const confirmarAsientos = (seleccionMesa, datosEntradas = null, datosMenores = null) => {
    setCantidad((prev) => ({
      ...prev,
      [tarifaSeleccionada.id]: seleccionMesa.cantidad,
    }));

    setAsientosSeleccionados((prev) => ({
      ...prev,
      [tarifaSeleccionada.id]: {
        asientos: seleccionMesa.asientos,
        mesas: seleccionMesa.mesas,
        metadata: seleccionMesa.metadata
      },
    }));

    if (datosMenores && datosMenores.cantidad > 0) {
      setCantidad((prev) => ({
        ...prev,
        [datosMenores.tarifaId]: datosMenores.cantidad,
      }));
    }

    if (datosEntradas && datosEntradas.agregarEntradas && datosEntradas.tarifaId) {
      const cantidadEntradas = datosEntradas.cantidad || 0;

      if (cantidadEntradas > 0) {
        setCantidad((prev) => ({
          ...prev,
          [datosEntradas.tarifaId]: (prev[datosEntradas.tarifaId] || 0) + cantidadEntradas,
        }));
      }
    }

    setModalSeleccionOpen(false);
    setTarifaSeleccionada(null);
  };

  const eliminarSeleccion = (tarifaId) => {
    setCantidad(prev => {
      const newCantidad = {
        ...prev,
        [tarifaId]: 0
      };

      //MOUSSY
      // eliminar la tarifa de menor si se elimina la mesa
      //la tarifa menor solo se muestra en el modal de la mesa
      const TARIFAS_MENORES = [702, 703, 704];

      TARIFAS_MENORES.forEach(tarifaMenor => {
        if (prev[tarifaMenor] !== undefined) {
          newCantidad[tarifaMenor] = 0;
        }
      });
      tarifasLigadas(indiceMapa, tarifaId).forEach((id) => {
        newCantidad[id] = 0;
      });

      return newCantidad;
    });

    setAsientosSeleccionados(prev => {
      const nuevo = { ...prev, [tarifaId]: { asientos: [], mesas: {} } };
      tarifasLigadas(indiceMapa, tarifaId).forEach((id) => {
        nuevo[id] = { asientos: [], mesas: {} };
      });
      return nuevo;
    });
  };

  const { isAuthenticated, loginWithRedirect } = useAuth();

  const incremento = (idtarifa) => {
    setCantidad((prevCantidades) => {
      const nuevaCantidad = (prevCantidades[idtarifa] || 0) + 1;

      const tarifa = data?.tarifas?.find((tarifa) => tarifa.id === idtarifa);
      const limite = tarifa?.limite_persona || 5;

      if (nuevaCantidad > limite) {
        return prevCantidades;
      }

      return {
        ...prevCantidades,
        [idtarifa]: nuevaCantidad,
      };
    });
  };

  const decremento = (idtarifa) => {
    setCantidad((prevCantidades) => ({
      ...prevCantidades,
      [idtarifa]: Math.max(0, (prevCantidades[idtarifa] || 0) - 1),
    }));
  };

  /* CALCULOS TARIFAS */
  const calculoSubtotalTarifa = (tarifa) => {
    const cantidadTarifa = cantidad[tarifa.id] || 0;

    if (isPreview) {
      return cantidadTarifa * tarifa.precio;
    }

    if (asientosSeleccionados[tarifa.id]?.metadata?.precioMesa) {
      return asientosSeleccionados[tarifa.id].metadata.precioMesa;
    }
    if (cantidadTarifa > 0 && asientosSeleccionados[tarifa.id]?.precioTotal != null) {
      return asientosSeleccionados[tarifa.id].precioTotal;
    }

    return cantidadTarifa * tarifa.precio;
  };

  const subtotal =
    data?.tarifas?.reduce((acc, tarifa) => {
      return acc + calculoSubtotalTarifa(tarifa);
    }, 0) || 0;

  const comision =
    data?.tarifas?.reduce((acc, tarifa) => {
      const cantidadTarifa = cantidad[tarifa.id] || 0;

      let precioBase = tarifa.precio;
      if (!isPreview && asientosSeleccionados[tarifa.id]?.metadata?.precioMesa) {
        precioBase = asientosSeleccionados[tarifa.id].metadata.precioMesa;
      }

      if (!isPreview && cantidadTarifa > 0 && asientosSeleccionados[tarifa.id]?.comisionTotal != null) {
        return acc + asientosSeleccionados[tarifa.id].comisionTotal;
      }
      const precioConComision = !tarifa?.asumir_comision ? tarifa?.costo_servicio : 0;
      return acc + cantidadTarifa * precioConComision;
    }, 0) || 0;

  const calcularTotal = () => {
    const total = subtotal + comision;
    return total;
  };

  const totalFormateado = calcularTotal().toLocaleString("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  });

  const handleStartPurchase = async () => {
    if (isPreview) {
      toggleDrawer(true)();
      return;
    }

    const seleccionadas = data.tarifas.filter(
      (tarifa) => (cantidad[tarifa.id] || 0) > 0
    );

    if (!isAuthenticated) {
      await loginWithRedirect({
        appState: { returnTo: window.location.pathname },
      });
      return;
    }

    try {
      await fetchCSRFToken();
      /*  console.log("CSRF Token obtenido correctamente:", sessionStorage.getItem('csrf_token')); */
    } catch (error) {
      console.error("Error obteniendo token CSRF:", error);
    }

    setTarifasSeleccionadas(seleccionadas.map(tarifa => ({
      ...tarifa,
      asientosSeleccionados: asientosSeleccionados[tarifa.id] || { asientos: [], mesas: {} }
    })));
    toggleDrawer(true)();
  };

  const ordenarTarifasPorColor = (tarifas) => {
    if (!Array.isArray(tarifas)) return [];

    return [...tarifas].sort((a, b) => {
      try {
        const colorA = typeof a.color === 'string' ? JSON.parse(a.color) : a.color;
        const colorB = typeof b.color === 'string' ? JSON.parse(b.color) : b.color;

        if (colorA.r !== colorB.r) return colorA.r - colorB.r;
        if (colorA.g !== colorB.g) return colorA.g - colorB.g;
        if (colorA.b !== colorB.b) return colorA.b - colorB.b;
        return (colorA.a || 1) - (colorB.a || 1);
      } catch {
        return 0;
      }
    });
  };

  const tarifasTicketsOrdenadas = ordenarTarifasPorColor(tarifasTicketsFiltrados);
  const tarifasVouchersOrdenadas = ordenarTarifasPorColor(tarifasVouchersFiltrados);

  return (
    <div className="w-100 pb-4" style={{ maxWidth: "400px", marginRight: "40px" }}>
      {(!tarifasTicketsOrdenadas && !tarifasVouchersOrdenadas) ||
        (tarifasTicketsOrdenadas?.length === 0 &&
          tarifasVouchersOrdenadas?.length === 0) ? (
        <>
          <div
            className="d-flex align-items-center flex-column "
            style={{ position: "sticky", top: "0", paddingTop: "28px" }}
          >
            <div
              className="contenedor-badge px-4 py-2"
              style={{
                background: "#dadaff",
                color: "#3d2eab",
                fontSize: "24px",
              }}
            >
              <CampaignOutlined
                sx={{
                  width: "45px",
                  height: "45px",
                  marginRight: "22px",
                }}
              />
              {/* <div className="d-flex flex-column">
                <small className="fw-bold" style={{ fontSize: "18px" }}>
                ¡Gracias por tu interés!
                </small>
                <small style={{ fontSize: "14px" }}>
                Actualmente no hay entradas disponibles para este evento.
                </small>
              </div> */}
              <div className="d-flex flex-column">
                <small className="fw-bold" style={{ fontSize: "18px", }}>
                  ¡Estate atento/a y no te quedes afuera!
                </small>
                <small style={{ fontSize: "16px" }}>
                  Próximamente, entradas a la venta.
                </small>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {(tarifasTicketsOrdenadas?.length > 0 ||
            tarifasVouchersOrdenadas?.length > 0) && (
              <div
                style={{ position: "sticky", top: "0", paddingTop: "28px" }}
              >
                {tarifasTicketsOrdenadas?.length > 0 && (
                  <TableContainer
                    sx={{ borderRadius: "10px", border: "1px solid #ddd" }}
                  >
                    <Table size="small">
                      <TableHead sx={{ backgroundColor: "#FFD400" }}>
                        <TableRow>
                          <TableCell
                            sx={{
                              fontFamily: "Inter, sans-serif",
                              padding: "6px 16px",
                            }}
                          >
                            ENTRADAS
                          </TableCell>
                          <TableCell
                            sx={{ fontFamily: "Inter, sans-serif" }}
                          >
                            PRECIO
                          </TableCell>
                          <TableCell
                            sx={{
                              fontFamily: "Inter, sans-serif",
                              textAlign: "center",
                            }}
                          >
                            CANT.
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tarifasTicketsOrdenadas?.map((tarifa) => (
                          <TableRow key={tarifa.id} sx={{}}>
                            <TableCell
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                border: "0",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px", /* padding: "0 8px", */ width: "100%" }}>
                                <div
                                  style={{
                                    backgroundColor: rgbaObjToString(tarifa.color),
                                    height: "12px",
                                    width: "12px",
                                    minWidth: "12px",
                                    maxWidth: "12px",
                                    borderRadius: "50%",
                                    flexShrink: 0,
                                    display: "inline-block"
                                  }}
                                />
                                <p style={{
                                  marginBottom: "0",
                                  flex: 1,
                                  wordWrap: "break-word",
                                  lineHeight: "1.2"
                                }}>
                                  {tarifa.concepto}
                                </p>
                                {tarifa.requiere_aprobacion && (
                                  <Tooltip
                                    arrow
                                    TransitionComponent={Zoom}
                                    placement="top"
                                    title="Esta entrada requiere la aprobación del organizador. Al solicitarla no se envía automáticamente: queda pendiente hasta que la acepten."
                                  >
                                    <InfoOutlined sx={{ width: "16px", height: "16px", color: "#5656ff", marginLeft: "4px", cursor: "help", flexShrink: 0 }} />
                                  </Tooltip>
                                )}
                              </div>
                            </TableCell>
                            <TableCell
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                border: "0",
                              }}
                            >
                              {precioLista(indiceMapa, tarifa).desde && "desde "}${precioLista(indiceMapa, tarifa).precio}
                            </TableCell>
                            <TableCell sx={{ fontFamily: "Inter, sans-serif", border: "0" }}>
                              <div className="d-flex flex-row gap-4">
                                {tarifa?.disponible ? (
                                  <>
                                    {/* TARIFAS TIPO 1*/}
                                    {(!tarifa.ubicacion || tarifa.ubicacion.tipo_ubicacion === 1) ? (
                                      <>
                                        <Button
                                          className=""
                                          disabled={cantidad[tarifa.id] === 0}
                                          onClick={() => decremento(tarifa.id)}
                                          sx={{
                                            minWidth: "3px",
                                            width: "17px !important",
                                            height: "17px",
                                            color: cantidad[tarifa.id] === 0 ? "#ddd" : "white",
                                            backgroundColor: cantidad[tarifa.id] === 0 ? "#ddd" : "#5656ff",
                                            padding: "0",
                                            fontSize: "15px !important",
                                            textAlign: "center",
                                          }}
                                          aria-label="restar"
                                        >
                                          -
                                        </Button>
                                        <Button
                                          className="fw-bold"
                                          disabled
                                          sx={{
                                            minWidth: "3px",
                                            width: "17px !important",
                                            height: "17px",
                                            color: "black",
                                            cursor: "default",
                                            padding: "0",
                                            "&.Mui-disabled": {
                                              color: "black",
                                              pointerEvents: "none",
                                            },
                                          }}
                                        >
                                          {cantidad[tarifa.id] || 0}
                                        </Button>
                                        <Button
                                          className=""
                                          onClick={() => incremento(tarifa.id)}
                                          sx={{
                                            minWidth: "3px",
                                            width: "17px !important",
                                            height: "17px",
                                            color: "white",
                                            backgroundColor: "#5656ff",
                                            padding: "0",
                                            fontSize: "15px !important",
                                            textAlign: "center",
                                          }}
                                          aria-label="sumar"
                                        >
                                          +
                                        </Button>
                                      </>
                                    ) : (
                                      /* TARIFA TIPO 2 Y 3 */
                                      <>
                                        {!(asientosSeleccionados[tarifa.id]?.asientos?.length > 0 || Object.keys(asientosSeleccionados[tarifa.id]?.mesas || {}).length > 0) ? (
                                          <Button
                                            variant="contained"
                                            onClick={() => abrirModalSeleccion(tarifa)}
                                            sx={{
                                              height: "32px",
                                              bgcolor: "#5656ff",
                                              color: "white",
                                              fontSize: '12px',
                                              padding: '4px 12px',
                                              '&:hover': { bgcolor: '#4545CC' }
                                            }}
                                          >
                                            Seleccionar
                                          </Button>
                                        ) : (
                                          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: 'center', width: "100%", gap: "20px" }}>
                                            <Typography
                                              onClick={() => abrirModalSeleccion(tarifa)}
                                              sx={{ color: "#5656ff", fontSize: "20px", fontWeight: 700, cursor: "pointer" }}>
                                              {`${asientosSeleccionados[tarifa.id]?.mesas &&
                                                Object.keys(asientosSeleccionados[tarifa.id].mesas).length > 0
                                                ? Object.keys(asientosSeleccionados[tarifa.id].mesas).length
                                                : (asientosSeleccionados[tarifa.id]?.asientos?.length || 0)
                                                }`}
                                            </Typography>
                                            <IconButton
                                              sx={{
                                                bgcolor: "transparent",
                                                color: "red",
                                                fontSize: '12px !important',
                                                padding: '0',
                                                border: 'none',
                                                display: "flex",
                                                '&:hover': { color: '#0b0062' }
                                              }}
                                              onClick={() => eliminarSeleccion(tarifa.id)}
                                              aria-label="delete"
                                              size="small"
                                            >
                                              <DeleteOutline style={{ color: "red" }} />
                                            </IconButton>
                                            {/* <Button
                                              variant="outlined"
                                              onClick={() => abrirModalSeleccion(tarifa)}
                                              sx={{
                                                bgcolor: "#ceceff",
                                                color: "#5656ff",
                                                fontSize: '12px !important',
                                                padding: '4px 10px',
                                                border: '1px solid #5656ff',
                                                display: "flex",
                                                '&:hover': { bgcolor: '#e0e7ff' }
                                              }}
                                            >
                                              Seleccionados ({`${(asientosSeleccionados[tarifa.id]?.asientos?.length || 0) +
                                                Object.values(asientosSeleccionados[tarifa.id]?.mesas || {}).reduce((a, b) => a + b, 0)
                                                }`})
                                            </Button> */}
                                            {/* <Button
                                              variant="text"
                                              color="error"
                                              onClick={() => eliminarSeleccion(tarifa.id)}
                                              sx={{
                                                fontSize: '12px',
                                                padding: '4px 8px',
                                              }}
                                            >
                                              Eliminar
                                            </Button> */}
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <small className="cartel-agotados p-1 rounded">
                                    <CloseOutlined sx={{ width: "16px", height: "16px" }} /> Agotado
                                  </small>
                                )}
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
                <div style={{ marginTop: "15px" }}>
                  {tarifasVouchersOrdenadas.length > 0 && (
                    <TableContainer
                      sx={{
                        borderRadius: "10px",
                        border: "1px solid #ddd",
                      }}
                    >
                      <Table size="small">
                        <TableHead sx={{ backgroundColor: "#FFD400" }}>
                          <TableRow>
                            <TableCell
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                padding: "6px 16px",
                              }}
                            >
                              VOUCHER
                            </TableCell>
                            <TableCell
                              sx={{ fontFamily: "Inter, sans-serif" }}
                            >
                              PRECIO
                            </TableCell>
                            <TableCell
                              sx={{
                                fontFamily: "Inter, sans-serif",
                                textAlign: "center",
                              }}
                            >
                              CANT.
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {tarifasVouchersOrdenadas.map((tarifa) => (
                            <TableRow key={tarifa.id} sx={{}}>
                              <TableCell
                                sx={{
                                  fontFamily: "Inter, sans-serif",
                                  border: "0",
                                }}
                              >
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px", /* padding: "0 8px", */ width: "100%" }}>
                                  <div
                                    style={{
                                      backgroundColor: rgbaObjToString(tarifa.color),
                                      height: "12px",
                                      width: "12px",
                                      minWidth: "12px",
                                      maxWidth: "12px",
                                      borderRadius: "50%",
                                      flexShrink: 0,
                                      display: "inline-block"
                                    }}
                                  />
                                  <p style={{
                                    marginBottom: "0",
                                    flex: 1,
                                    wordWrap: "break-word",
                                    lineHeight: "1.2"
                                  }}>
                                    {tarifa.concepto}
                                  </p>
                                </div>
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontFamily: "Inter, sans-serif",
                                  border: "0",
                                }}
                              >
                                ${tarifa.precio}
                              </TableCell>
                              <TableCell
                                sx={{
                                  fontFamily: "Inter, sans-serif",
                                  border: "0",
                                }}
                              >
                                <div className="d-flex flex-row gap-4">
                                  {tarifa?.disponible ? (
                                    <>
                                      <Button
                                        className=""
                                        disabled={cantidad[tarifa.id] === 0}
                                        onClick={() =>
                                          decremento(tarifa.id)
                                        }
                                        sx={{
                                          minWidth: "3px",
                                          width: "17px !important",
                                          height: "17px",
                                          color:
                                            cantidad[tarifa.id] === 0
                                              ? "#ddd"
                                              : "white",
                                          backgroundColor:
                                            cantidad[tarifa.id] === 0
                                              ? "#ddd"
                                              : "#5656ff",
                                          padding: "0",
                                          fontSize: "15px !important",
                                          textAlign: "center",
                                        }}
                                        aria-label="restar"
                                      >
                                        -
                                      </Button>
                                      <Button
                                        className="fw-bold"
                                        disabled
                                        sx={{
                                          minWidth: "3px",
                                          width: "17px !important",
                                          height: "17px",
                                          color: "black",
                                          cursor: "default",
                                          padding: "0",
                                          "&.Mui-disabled": {
                                            color: "black",
                                            pointerEvents: "none",
                                          },
                                        }}
                                      >
                                        {cantidad[tarifa.id] || 0}
                                      </Button>
                                      <Button
                                        className=""
                                        onClick={() =>
                                          incremento(tarifa.id)
                                        }
                                        sx={{
                                          minWidth: "3px",
                                          width: "17px !important",
                                          height: "17px",
                                          color: "white",
                                          backgroundColor: "#5656ff",
                                          padding: "0",
                                          fontSize: "15px !important",
                                          textAlign: "center",
                                        }}
                                        aria-label="sumar"
                                      >
                                        +
                                      </Button>
                                    </>
                                  ) : (
                                    <small className="cartel-agotados p-1 rounded">
                                      <CloseOutlined
                                        sx={{
                                          width: "16px",
                                          height: "16px",
                                        }}
                                      />{" "}
                                      Agotado
                                    </small>
                                  )}
                                </div>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </div>
                <div
                  className="d-flex flex-column"
                  style={{
                    width: "100%",
                    backgroundColor: grey[200],
                    borderRadius: "5px",
                    marginTop: "15px",
                  }}
                >
                  <div
                    className="d-flex justify-content-between flex-wrap py-2"
                    style={{
                      backgroundColor: "transparent",
                      padding: "6px 16px",
                    }}
                  >
                    <div className="d-flex flex-row align-items-center">
                      <p
                        className="fw-bold mb-0 fs-6"
                        style={{
                          color: !Object.values(cantidad).some(
                            (val) => val > 0
                          )
                            ? grey[800]
                            : "black",
                        }}
                      >
                        TOTAL
                      </p>
                      <Tooltip
                        arrow
                        TransitionComponent={Zoom}
                        placement="right"
                        title="El precio incluye impuestos"
                      >
                        <InfoOutlined
                          sx={{
                            width: "18px",
                            height: "18px",
                            marginLeft: "5px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <span className="text-end">
                      <p
                        className="fw-bold mb-0 fs-6"
                        style={{
                          color: !Object.values(cantidad).some(
                            (val) => val > 0
                          )
                            ? grey[800]
                            : "black",
                        }}
                      >
                        $ {totalFormateado}
                      </p>
                    </span>
                  </div>
                  <Button
                    className=""
                    onClick={handleStartPurchase}
                    sx={{
                      padding: "8px 10px",
                      fontFamily: "Inter, sans-serif",
                      backgroundColor: "#5656FF",
                      outline: "none",
                      color: "white",
                      borderRadius: "10px !important",
                      "&:disabled": {
                        backgroundColor: "#ddd",
                        color: grey[800],
                      },
                    }}
                    disabled={
                      !Object.values(cantidad).some((val) => val > 0)
                    }
                  >
                    {eventoTieneTarifasConAprobacion(data.tarifas) ? "Solicitar acreditación" : "Comenzar compra"}{" "}
                    <ShoppingCartOutlined
                      sx={{
                        color: !Object.values(cantidad).some(
                          (val) => val > 0
                        )
                          ? grey[800]
                          : "white",
                        width: "18px",
                        height: "18px",
                        marginLeft: "5px",
                      }}
                    />
                  </Button>
                </div>
              </div>
            )}
        </>
      )}
      {!isPreview && (
        <SelectorLugares
          open={modalSeleccionOpen}
          onClose={() => {
            setModalSeleccionOpen(false);
            setTarifaSeleccionada(null);
          }}
          tarifa={tarifaSeleccionada}
          cantidadSeleccionada={cantidad[tarifaSeleccionada?.id] || 1}
          onConfirmar={confirmarAsientos}
          seleccionActual={seleccionActual}
          tarifasTicketsFiltrados={tarifasTicketsFiltrados}
          cantidad={cantidad}
          asientosSeleccionados={asientosSeleccionados}
          setCantidad={setCantidad}
          setAsientosSeleccionados={setAsientosSeleccionados}
        />
      )}
    </div>
  );
};

export default EventoTarifas;